import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MutualFundsComponent } from './page/mutual-funds/mutual-funds.component';
import { UploadHistoryComponent } from './page/upload-history/upload-history.component';
import { ClientOnboardingComponent } from './page/client-onboarding/client-onboarding.component';
const routes: Routes = [
  {
    path: 'mutual-funds',
    component: MutualFundsComponent
  },
  {
    path: 'uitf',
    component: MutualFundsComponent
  },
  {
    path: 'client-onboarding',
    component: ClientOnboardingComponent
  },
  {
    path: 'upload-history',
    component: UploadHistoryComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FileUploadRoutingModule { }
